<template>
  <router-view/>
</template>

<script>
import { loadNaverCommonScript } from '@/tarot_box/helper/native_api.js';
import 'vue-loading-overlay/dist/css/index.css';


export default {
  name: 'App',
  data() {
    return {
      transitionName: 'slide-left',
    };
  },
  mounted() {
    loadNaverCommonScript();
    this.checkBuildNumber();
  },
  methods: {
    checkBuildNumber() {
      // 현재 경로가 이미 update 페이지인지 확인 (무한 리다이렉트 방지)
      if (this.$route.path === '/tarot_box/update') {
        return;
      }

      // URL 파라미터에서 build_number 읽기
      const urlParams = new URLSearchParams(window.location.search);
      const buildNumberParam = urlParams.get('build_number');

      if (buildNumberParam) {
        // 문자열을 숫자로 변환
        const buildNumber = parseInt(buildNumberParam, 10);

        // build_number가 196인 경우 업데이트 페이지로 리다이렉트
        if (buildNumber === 196) {
          // 현재 URL의 모든 파라미터를 객체로 변환
          const allParams = {};
          for (const [key, value] of urlParams.entries()) {
            allParams[key] = value;
          }

          // Vue Router를 사용해서 리다이렉트 (모든 쿼리 파라미터 보존)
          this.$router.push({
            path: '/tarot_box/update',
            query: allParams
          });
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      this.transitionName = from.path.startsWith('/home') && to.path.startsWith('/tarot/detail') ? 'slide-left' : 'slide-right';

      // 라우트 변경 시에도 build_number 체크 (선택사항)
      // this.checkBuildNumber();
    }
  }
}
</script>

<style>
@import './styles/text_style.css';
@import './styles/colors.css';



:root {
  color-scheme: light only;
  /* vue-bottom-sheet 패딩 강제 */
  --bottom-sheet-padding: 0px;
}

@media (prefers-color-scheme: dark) {
  html, body {
    background: #fff !important;
    background-color: #fff !important;
  }
}
html,body{
  height: 100%;
  margin: 0;
  padding: 0;
  align-items: center;
  -webkit-backface-visibility:  hidden;
  -webkit-touch-callout : none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
  background-color: var(--Grayscale-Gray12);
}
::-webkit-scrollbar {
  width: 0;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
}

button{
  -webkit-appearance: none; /* remove default appearance on Webkit-based browsers */
  -moz-appearance: none; /* remove default appearance on Mozilla-based browsers */
  appearance: none; /* remove default appearance on all other browsers */
  -webkit-tap-highlight-color: transparent;
  -webkit-text-size-adjust : none;  /* 크롬, 사파리, 오페라 신버전 */
  -ms-text-size-adjust : none;  /* IE */
  -moz-text-size-adjust : none;  /* 파이어폭스 */
  -o-text-size-adjust : none;  /* 오페라 구버전 */
  font-family: inherit;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
}


#app {
  font-family: "SUIT Variable", sans-serif;
  -webkit-text-size-adjust:none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--Grayscale-Gray1);
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  height: 100%;
  overflow: hidden;
}


input {
  font-family: inherit;
  outline:none;
  border:none;
  resize: none;
  background: none;
  font-size:inherit;
  font-weight:inherit;
  color:inherit;
  line-height: inherit;
  border-radius: 0;
}

textarea {
  font-family: inherit;
  outline:none;
  border:none;
  resize: none;
  background: none;
}

.flicking-camera{
  display: flex;
}

*::-webkit-scrollbar {
  display: none;
}

</style>